const emptyTiptapDocument = {
  type: 'doc',
  content: [],
};

export const isTiptapDocument = (value) => (
  value
  && typeof value === 'object'
  && value.type === 'doc'
  && (value.content === undefined || Array.isArray(value.content))
);

export const normalizeTiptapDocument = (value) => {
  if (isTiptapDocument(value)) {
    return value;
  }

  if (typeof value === 'string') {
    try {
      const parsed = JSON.parse(value);
      if (isTiptapDocument(parsed)) {
        return parsed;
      }
    } catch (error) {
      return {
        type: 'doc',
        content: value.trim()
          ? [{ type: 'paragraph', content: [{ type: 'text', text: value }] }]
          : [],
      };
    }
  }

  return emptyTiptapDocument;
};

export const buildEditorPayload = (editor) => {
  if (!editor) {
    return {
      contentJson: emptyTiptapDocument,
      renderedHtml: '',
      plainText: '',
      content: '',
    };
  }

  const html = editor.getHTML();
  return {
    contentJson: editor.getJSON(),
    renderedHtml: html,
    plainText: editor.getText({ blockSeparator: '\n' }),
    content: html,
  };
};

export const stableSerialize = (value) => JSON.stringify(value || null);

export const getWikiUserChangePayload = (payload = {}) => {
  const {
    editVersion,
    edit_version: editVersionSnakeCase,
    updatedAt,
    updated_at: updatedAtSnakeCase,
    ...userFields
  } = payload || {};

  return userFields;
};
